module.exports = __webpack_public_path__ + "img/price-1.affd96ca.png";